export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_MAXIMUM_PAGE_SIZE = -1;
export const INITIAL_PAGE = 1;

export const ACCESS_TOKEN = "access_token";
export const LANGUAGE_CODE = "i18nextLng";

export const DATE_FORMATE = "DD-MM-YYYY, LT";

export const DEFAULT_FUNCTION = () => null;
export const DEFAULT_QUERY = {
  page: INITIAL_PAGE,
  perPage: DEFAULT_PAGE_SIZE,
};

export const DEFAULT_MAP_CENTER = {
  lat: 25.2048,
  lng: 55.2708,
};

export const languages = [
  {
    code: "ar",
    name: "العربية",
    isMain: true,
  },
  {
    code: "en",
    name: "English",
    isMain: true,
  },
  {
    code: "fr",
    name: "Français",
    isMain: true,
  },
];

export const countryStats = [
  { name: "أمريكا", color: "#74b9ff", value: "5.525" },
  { name: "ألمانيا", color: "#ffeaa7", value: "445.525" },
  { name: "فرنسا", color: "#00b894", value: "5.525" },
  { name: "اسبانيا", color: "red", value: "578" },
  { name: "المملكة المتحدة", color: "#6c5ce7", value: "578" },
  { name: "هولندا", color: "#0984e3", value: "578" },
  { name: "بولندا", color: "#00cec9", value: "420" },
  { name: "ايطاليا", color: "yellow", value: "456" },
  { name: "ماليزيا", color: "red", value: "878" },
  { name: "اليابان", color: "#6c5ce7", value: "878" },
];

export const countryStatsSecond = [
  { name: "أمريكا", color: "#74b9ff", value: "11" },
  { name: "ألمانيا", color: "#ffeaa7", value: "15" },
  { name: "فرنسا", color: "#00b894", value: "30" },
  { name: "اسبانيا", color: "red", value: "20" },
  { name: "المملكة المتحدة", color: "#6c5ce7", value: "58" },
  { name: "هولندا", color: "#0984e3", value: "40" },
  { name: "بولندا", color: "#00cec9", value: "20" },
  { name: "ايطاليا", color: "yellow", value: "35" },
  { name: "ماليزيا", color: "red", value: "24" },
  { name: "اليابان", color: "#6c5ce7", value: "15" },
];
